import "./scrollbar-width";



// WEBPACK FOOTER //
// ./project/client/src/core/components/scrollbar-width/index.js